import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { LegalEntityViewModel } from '@app/_models/_viewModels/legalEntity.viewmodel';
import { UploadFile, NzMessageService } from 'ng-zorro-antd';
import { Media } from '@app/_models/_DTOs/media';
import { environment } from '@environments/environment';
import { NgForm } from '@angular/forms';
import { HttpEventType } from '@angular/common/http';
import { LegalEntity } from '@app/_models/_DTOs/legalEntity';
import { ResizeService } from '@app/_services/resize.service';
import { DocumentService } from '@app/_services/document.service';
import { Location } from '@app/_models/_DTOs/location';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { AutonumericOptions } from '@angularfy/autonumeric/lib/autonumeric.model';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { LegalEntityService } from '@app/_services/legalEntity.service';
import { LegalEntityEditorComponent } from '../legal-entity-editor/legal-entity-editor.component';


@Component({
  selector: "app-legal-entity-editor-drawer",
  templateUrl: "./legal-entity-editor-drawer.component.html",
  styleUrls: ["./legal-entity-editor-drawer.component.css"],
})
export class LegalEntityEditorDrawerComponent implements OnInit {
  @Input() hiddenFields: string[];
  @Input() disabledFields: string[];
  @Input() legalEntityViewModel: LegalEntityViewModel;
  @Input() isEditing: boolean;
  @Output() drawerClosed = new EventEmitter<boolean>();

  @ViewChild(LegalEntityEditorComponent, { static: false })
  private legalEntityEditorComponent: LegalEntityEditorComponent;

  public createForm: NgForm;

  drawerWidth: string;

  isSavingLegalEntity: boolean = false;

  errorMessages = {};

  apiUrl: string;

  private delayTimer;

  constructor(
    private legalEntityService: LegalEntityService,
    private messageService: NzMessageService,
    private resizeService: ResizeService
  ) {
    this.apiUrl = environment.apiUrl;
    this.resizeService.onResize$.subscribe((size) => {
      this.drawerWidth = this.resizeService.getDrawerWidth();
    });
  }

  ngOnInit() {
    if (this.resizeService.currentSize != null) {
      this.drawerWidth = this.resizeService.getDrawerWidth();
    }
  }

  closeDrawer(legalEntityId?: number) {
    this.legalEntityEditorComponent.resetForm();
    this.drawerClosed.emit(legalEntityId != null);
  }
}
